import { useForceUpdate, useIsomorphicLayoutEffect } from '../helpers';
import { useRef } from 'react';
/**
 *
 * @template TInput Input value within Observable.
 *
 * @param useCustomEffect useEffect or useLayoutEffect
 * @param args collected arguments
 */
export function useSubscriptionInternal(useCustomEffect, args) {
    var forceUpdate = useForceUpdate();
    var argsRef = useRef(args);
    var errorRef = useRef();
    var subscriptionRef = useRef();
    // Update the latest observable and callbacks
    // synchronously after render being committed
    useIsomorphicLayoutEffect(function () {
        argsRef.current = args;
    });
    useCustomEffect(function () {
        errorRef.current = null;
        // keep in closure for checking staleness
        var input$ = argsRef.current[0];
        var subscription = input$.subscribe({
            next: function (value) {
                var _a;
                if (input$ !== argsRef.current[0]) {
                    // stale observable
                    return;
                }
                var nextObserver = ((_a = argsRef.current[1]) === null || _a === void 0 ? void 0 : _a.next) ||
                    argsRef.current[1];
                if (nextObserver) {
                    return nextObserver(value);
                }
            },
            error: function (error) {
                var _a;
                if (input$ !== argsRef.current[0]) {
                    // stale observable
                    return;
                }
                var errorObserver = ((_a = argsRef.current[1]) === null || _a === void 0 ? void 0 : _a.error) ||
                    argsRef.current[2];
                if (errorObserver) {
                    errorRef.current = null;
                    return errorObserver(error);
                }
                errorRef.current = error;
                forceUpdate();
            },
            complete: function () {
                var _a;
                if (input$ !== argsRef.current[0]) {
                    // stale observable
                    return;
                }
                var completeObserver = ((_a = argsRef.current[1]) === null || _a === void 0 ? void 0 : _a.complete) ||
                    argsRef.current[3];
                if (completeObserver) {
                    return completeObserver();
                }
            }
        });
        subscriptionRef.current = subscription;
        return function () {
            subscription.unsubscribe();
        };
    }, [args[0]]);
    if (errorRef.current) {
        // Let error boundary catch the error
        throw errorRef.current;
    }
    return subscriptionRef;
}
//# sourceMappingURL=use-subscription-internal.js.map